import { checkEnvVars, Dict } from '@ajorquera/libs/utils';

export const IDENTITY_PLATFORM_AUTH_DOMAIN = import.meta.env.REACT_APP_GCP_IDENTITY_PLATFORM_AUTH_DOMAIN;
export const IDENTITY_PLATFORM_API_KEY     = import.meta.env.REACT_APP_GCP_IDENTITY_PLATFORM_API_KEY;

export const SEND_SMS_ENDPOINT_URL = import.meta.env.REACT_APP_SEND_SMS_ENDPOINT_URL;
export const IS_GITHUB_PAGES       = import.meta.env.REACT_APP_IS_GITHUB_PAGES === 'true';
export const HOSTNAME              = import.meta.env.REACT_APP_HOSTNAME;
export const PUBLIC_URL            = import.meta.env.PUBLIC_URL || '';  

export const SEND_EMAIL_ENDPOINT_URL = import.meta.env.REACT_APP_SEND_EMAIL_ENDPOINT_URL;
export const SEND_EMAIL_API_KEY      = import.meta.env.REACT_APP_SEND_EMAIL_API_KEY;
export const SEND_EMAIL_REPLY        = import.meta.env.SEND_EMAIL_REPLY || 'support@' + HOSTNAME;
export const SEND_EMAIL_NAME         = import.meta.env.REACT_APP_SEND_EMAIL_NAME;
export const SEND_EMAIL_FROM         = import.meta.env.SEND_EMAIL_FROM || 'support@' + HOSTNAME;


export const GCP_FIRESTORE_DB_ID = import.meta.env.REACT_APP_GCP_FIRESTORE_DB_ID;
export const GCP_BUCKET_STORAGE  = import.meta.env.REACT_APP_GCP_BUCKET_STORAGE;
export const GCP_PROJECT_ID      = import.meta.env.REACT_APP_GCP_PROJECT_ID;


checkEnvVars(
  [
    'REACT_APP_GCP_IDENTITY_PLATFORM_AUTH_DOMAIN',
    'REACT_APP_GCP_IDENTITY_PLATFORM_API_KEY',
    'REACT_APP_SEND_EMAIL_ENDPOINT_URL',
    'REACT_APP_SEND_SMS_ENDPOINT_URL',
    'REACT_APP_GCP_FIRESTORE_DB_ID',
    'REACT_APP_GCP_BUCKET_STORAGE',
    'REACT_APP_SEND_EMAIL_API_KEY',
    'REACT_APP_GCP_PROJECT_ID',
    'REACT_APP_HOSTNAME',
  ],
  import.meta.env as unknown as Dict<string>
);
